import React from 'react';
import { Toast } from '../../Molecules/Toast';

export interface Props {
  onlineMessage: React.ReactNode;
  offlineMessage: React.ReactNode;
  onlineToastDuration?: number;
  offlineToastDuration?: number;
}

const ONE_HOUR_IN_MILLIS = 60 * 60 * 1000;

export interface InternalProps extends Props {
  isOnline: boolean;
}

export const InternetStatus: React.FC<Props> = (props: Props): JSX.Element => {
  const [isOnlineToastVisible, setIsOnlineToastVisible] = React.useState(false);
  const [isOfflineToastVisible, setIsOfflineToastVisible] = React.useState(
    !window.navigator.onLine
  );

  React.useEffect(() => {
    function handleOnline() {
      setIsOnlineToastVisible(true);
      setIsOfflineToastVisible(false);
    }
    function handleOffline() {
      setIsOfflineToastVisible(true);
      setIsOnlineToastVisible(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const {
    onlineMessage,
    offlineMessage,
    onlineToastDuration,
    offlineToastDuration,
  } = props;

  return (
    <>
      <Toast
        className="internet-status-online"
        showToast={isOnlineToastVisible}
        handleClose={() => setIsOnlineToastVisible(false)}
        duration={onlineToastDuration}
        severity="success"
        vertical="top"
        horizontal="center"
      >
        {onlineMessage}
      </Toast>
      <Toast
        className="internet-status-offline"
        showToast={isOfflineToastVisible}
        handleClose={() => setIsOfflineToastVisible(false)}
        duration={offlineToastDuration || ONE_HOUR_IN_MILLIS}
        severity="error"
        vertical="top"
        horizontal="center"
      >
        {offlineMessage}
      </Toast>
    </>
  );
};
